module.exports = __webpack_public_path__ + "assets/img/blast.2ec90a4f.png";